export const paymentMethodDropdown = [
  "CASH",
  "CHEQUE",
  "NEFT",
  "RTGS",
  "UPI",
  "LOAN_DISBURSEMENT",
];
